module.exports = __webpack_public_path__ + "static/img/cgal1.fd695f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal1.png
// module id = YXMa
// module chunks = 1